import type { Level } from '@/api/types';
import type { StageGrantActionState, StageGrantSummary } from './StageGrantsCard';
import StageGrantsPanel from './StageGrantsPanel';
import type { StageDraft, StageGrantsPanelState } from './StageGrantsPanel';

interface HeldStagesPanelProps {
  stages: StageGrantSummary[];
  stageActionState: StageGrantActionState | null;
  disabled: boolean;
  onSetStage: (stage: StageGrantSummary['stage'], level: Level | null) => void;
  onToggleStage: (stage: StageGrantSummary['stage']) => void;
  onApplyStages: () => void;
  onRetryStages: () => void;
  lockedMessage?: string;
}

// Stage별 권한의 오른쪽 열 — 저장되어 있거나 이번에 넣은 Stage.
export default function HeldStagesPanel({
  stages, stageActionState, disabled, onSetStage, onToggleStage, onApplyStages, onRetryStages, lockedMessage,
}: HeldStagesPanelProps) {
  const selectedStages = Object.fromEntries(stages
    .filter(stage => stage.changeKind !== 'revoke')
    .map(stage => [stage.stage, stage.level])) as StageDraft;
  const stageState: StageGrantsPanelState = stageActionState ? {
    ...stageActionState,
    count: stageActionState.heldStages.length,
    editable: stageActionState.editable && !disabled,
  } : {
    loaded: false,
    count: 0,
    editable: false,
    loadError: false,
    footerSummary: '변경 없음',
    buttonLabel: '변경 적용',
    buttonDisabled: true,
    showRetry: false,
  };
  return <StageGrantsPanel
    regionLabel="Stage별 보유 권한"
    detailsId="stage-grants-details-held"
    embedded
    headless
    title="보유 권한"
    selected={selectedStages}
    visibleStages={stageActionState?.heldStages ?? []}
    changeKinds={Object.fromEntries(stages.map(stage => [stage.stage, stage.changeKind]))}
    state={stageState}
    emptyMessage="왼쪽에서 Stage를 넣으면 여기에 표시됩니다."
    lockedMessage={lockedMessage}
    onToggleStage={onToggleStage}
    onSetStage={onSetStage}
    onApply={onApplyStages}
    onRetry={onRetryStages}
  />;
}
